@if (isSearching) {
    <mat-progress-bar mode="indeterminate" />
} @else {
    @if (groups.length > 0) {
        <ng-container class="container">
            @for (group of groups; track group.groupName) {
                <div class="search-group">
                    <div class="p-3">
                        <h2 class="header">{{ group.groupName }}</h2>
                        <table mat-table [dataSource]="group.items">
                            <ng-container matColumnDef="label">
                                <td mat-cell *matCellDef="let item" (click)="goToView(item)">
                                    <span>
                                        <i class="material-icons" [ngClass]="group.groupType" title="{{ group.groupName }}"></i>
                                    </span>
                                    &nbsp;
                                    <span>{{ item.label }}</span>
                                </td>
                            </ng-container>
                            <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
                        </table>
                    </div>
                </div>
            }
        </ng-container>
    } @else {
        <span>{{ 'General.NoSearchResult' | translate }}</span>
    }
}
